var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubStorageIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.563 20.25H6.374c-1.708 0-3.298-.59-4.477-1.66C.674 17.478 0 15.937 0 14.25c0-1.715.628-3.194 1.815-4.276.849-.775 1.98-1.325 3.243-1.588a.75.75 0 00.533-.429 7.324 7.324 0 011.97-2.625C8.802 4.298 10.337 3.75 12 3.75a7.199 7.199 0 015.022 2.01c1.16 1.117 1.946 2.592 2.306 4.313a.75.75 0 00.568.58C22.03 11.13 24 12.677 24 15.376c0 1.565-.574 2.849-1.66 3.713-.954.76-2.26 1.162-3.777 1.162z",
    fill: "#373737"
  })));
}
export default SvgSubStorageIc;